/* eslint-disable max-len */
import { API } from 'shared/utils/apiMiddleware';
import { sanitizeParam } from 'shared/utils/apiUtil';

class InvoicesApi {
  getMetricsTypes = () => API.get('billings', '/api/v1/invoices/metrics/types');
  getMetricsData = ({
    groupBy,
    startDate,
    endDate,
    periodGranLevel,
    filtersMap,
    excludedFiltersMap,
    dimensions,
    metric,
  }) => {
    const formattedGroupBy = sanitizeParam(groupBy);
    const arrDimensions = dimensions.map((d) => `&dimension=${d}`).join('');
    const apiQuery = `/api/v1/invoices/metrics?groupBy=${formattedGroupBy}&startDate=${startDate}&endDate=${endDate}&periodGranLevel=${periodGranLevel}${arrDimensions}${filtersMap}${excludedFiltersMap}&metricTypeId=${metric}`;
    return API.get('billings', apiQuery);
  };
  getServiceNames = async () => {
    const apiQuery = '/api/v1/invoices/service-names/distinct';
    return API.get('billings', apiQuery, true);
  };
  getK8sPodData = async (
    startDate,
    endDate,
    clusterName = null,
    nodeName = null,
    podName = null,
    namespaceName = null,
    isNetUnblended = false,
    isShowAmortize = false,
    isNetAmortize = false,
    isListUnitPrice = false,
    isSavingsCost = false,
  ) => {
    const showAmortize = isShowAmortize ? '&isAmortized=true' : '';
    const netAmortize = isNetAmortize ? '&isNetAmortized=true' : '';
    const netUnblended = isNetUnblended ? '&isNetUnblended=true' : '';
    const listUnitPriceCost = isListUnitPrice ? '&isListUnitPrice=true' : '';
    const negotiatedSavings = isSavingsCost ? '&isSavingsCost=true' : '';
    const apiQuery = `/api/v1/kubernetes/cost-and-usage/pod?startDate=${startDate}&endDate=${endDate}&source=unified&&clusterName=${clusterName}&namespaceName=${namespaceName}&nodeName=${nodeName}&podName=${podName}${listUnitPriceCost}${negotiatedSavings}${showAmortize}${netAmortize}${netUnblended}`;
    const result = await API.get('billings', apiQuery);
    return result;
  };
}

export default InvoicesApi;
